/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UploadEventFile
 */
export interface UploadEventFile {
  /**
   *
   */
  readonly putUrl?: string;
  /**
   *
   */
  filename: string;
  /**
   *
   */
  readonly status?: string;
  /**
   *
   */
  offset: number;
}

/**
 * Check if a given object implements the UploadEventFile interface.
 */
export function instanceOfUploadEventFile(value: object): value is UploadEventFile {
  if (!("filename" in value) || value["filename"] === undefined) return false;
  if (!("offset" in value) || value["offset"] === undefined) return false;
  return true;
}

export function UploadEventFileFromJSON(json: any): UploadEventFile {
  return UploadEventFileFromJSONTyped(json, false);
}

export function UploadEventFileFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UploadEventFile {
  if (json == null) {
    return json;
  }
  return {
    putUrl: json["put_url"] == null ? undefined : json["put_url"],
    filename: json["filename"],
    status: json["status"] == null ? undefined : json["status"],
    offset: json["offset"],
  };
}

export function UploadEventFileToJSON(json: any): UploadEventFile {
  return UploadEventFileToJSONTyped(json, false);
}

export function UploadEventFileToJSONTyped(
  value?: Omit<UploadEventFile, "putUrl" | "status"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    filename: value["filename"],
    offset: value["offset"],
  };
}
